import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const InfantryBarracks = {
  id: "7",
  name: "Infantry Barracks",
  width: 4,
  height: 4,
  type: BuildingType.BARRACKS,
  era: "stoneAge",
  icon: "LightInfantry",
  minLevel: 1,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Barracks/Infantry_Barracks',
  flags: 0,
  counts: {
    stoneAge: 2,
    bronzeAge: 2,
    minoanEra: 2,
    classicGreece: 2,
    earlyRome: 2,
    romanEmpire: 2,
    byzantineEra: 2,
    ageOfTheFranks: 2,
    feudalAge: 2,
    iberianEra: 2,
    kingdomOfSicily: 2,
    highMiddleAges: 2,
    earlyGothicEra: 2,
    lateGothicEra: 2,
  },
  effects: Effects.create([
    new Happiness({
      stoneAge: [100, 190, 380],
      bronzeAge: [140, 290, 580],
      minoanEra: [190, 380, 770],
      classicGreece: [260, 510, 1020],
      earlyRome: [320, 640, 1280],
      romanEmpire: [380, 770, 1540],
      byzantineEra: [450, 900, 1790],
      ageOfTheFranks: [540, 1090, 2180],
      feudalAge: [640, 1280, 2560],
      iberianEra: [770, 1540, 3070],
      kingdomOfSicily: [930, 1860, 3710],
      highMiddleAges: [1120, 2240, 4480],
      earlyGothicEra: [1345, 2690, 5380],
      lateGothicEra: [1600, 3200, 6400],
    })
  ]),
};

export default InfantryBarracks;
